<template>
  <div>
    <div class="w3-container">
      <header>
        <h2>Billing</h2>
      </header>
      <div class="w3-margin-bottom" :class="state.width > 1024 ? 'pageSidebarGrid':''">
        <main>
          <!-- Invoice List -->
          <invoicesList></invoicesList>

          <!-- Subscriptions List -->
          <subscriptionList></subscriptionList>
        </main>
        <aside class="w3-hide-print">
          <paymentMethods></paymentMethods>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import creditCard from '@/components/creditCard'
import invoicesList from '@/components/invoicesList'
import subscriptionList from '@/components/subscriptionList'
import paymentMethods from '@/components/paymentMethods'
var dataStore = require("../dataStore").default

export default {
  name: "Billing",
  data() {
    return {
      state: dataStore.state,
      invoiceDetails: false,
      activeInvoice: {}
    };
  },
  methods: {
    viewDetails(item) {
      console.log(item)
      this.invoiceDetails = true;
      this.activeInvoice = item;
    },
    viewSubDetails(item) {
      console.log(item)
    },
    payInvoice() {
      console.log("todo pay invoice") // TODO: pay invoice

    }
  },
  components: {creditCard, invoicesList, subscriptionList, paymentMethods}
};
</script>

<style scoped>
.invoiceRow {cursor:pointer;}
@media (max-width:993px) {
  aside {margin-top:8px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Billing.vue